import React, { FC, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<SVGSVGElement> {
  className?: string;
  size?: number;
  color?: string;
}

export const DottedCircleIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      stroke={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.20912"
        y="1.20912"
        width="21.5818"
        height="21.5818"
        rx="10.7909"
        strokeOpacity="0.6"
        strokeWidth="2.41824"
        strokeDasharray="4.84 4.84"
        fill="none"
      />
    </svg>
  );
};
